function initializePaymentMethods() {
    // Check if we're on the payments page
    if (!$('#payments_page').length) return;

    if ($('.method-content').data('payments-initialized')) return;

    $('.method-content').data('payments-initialized', true);

    // Handle only expandable tiles (those with .method-action) but exclude always-open blocks
    const $tiles = $('.method-tile:not(.disabled-tile):not(.always-open)').has('.method-action');

    // iDEAL bank selection handling
    const $idealBankSelect = $('#ideal-bank-select');
    const $idealSubmitBtn = $('#ideal-submit-btn');

    if ($idealBankSelect.length && $idealSubmitBtn.length) {
        $idealBankSelect.on('change.payments', function() {
            const selectedBank = $(this).val();
            $('#ideal-bank-hidden').val(selectedBank);

            if (selectedBank && selectedBank !== '0') {
                $idealSubmitBtn
                    .prop('disabled', false)
                    .removeClass('btn-secondary')
                    .addClass('btn-success')
                    .text($idealSubmitBtn.data('active-text'));
            } else {
                $idealSubmitBtn
                    .prop('disabled', true)
                    .removeClass('btn-success')
                    .addClass('btn-secondary')
                    .text($idealSubmitBtn.data('default-text'));
            }
        }).trigger('change');
    }

    // Handle clicks only on expandable tiles (excluding always-open blocks)
    $tiles.each(function() {
        const $tile = $(this);
        const $methodContent = $tile.find('.method-content');

        $methodContent.on('click.payments', function(e) {
            const $target = $(e.target);

            if ($target.is('select') ||
                $target.is('button') ||
                $target.is('input') ||
                $target.closest('select').length ||
                $target.closest('button').length ||
                $target.closest('input').length) {
                return;
            }

            const isActive = $tile.hasClass('active');
            $('.method-tile:not(.always-open)').removeClass('active');

            if (!isActive) {
                setTimeout(() => $tile.addClass('active'), 10);
            }
        });

        $methodContent.on('keydown.payments', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    });

    // Close tiles when clicking outside (excluding always-open blocks)
    $(document).on('click.payments', function(e) {
        if (!$(e.target).closest('.method-tile').length) {
            $('.method-tile:not(.always-open)').removeClass('active');
        }
    });

    handleSaveCardCheckbox();
}

function handleSaveCardCheckbox() {
    $(document).off('click.saveCardCheckbox');

    $(document).on('click.saveCardCheckbox', '.form-check-label', function(e) {
        const label = $(this);
        const checkboxId = label.attr('for');

        if (!checkboxId) return;

        const checkbox = document.getElementById(checkboxId);
        if (!checkbox) return;

        if (e.target !== checkbox) {
            checkbox.checked = !checkbox.checked;

            const event = new Event('change', { bubbles: true });
            checkbox.dispatchEvent(event);

            e.stopPropagation();
            return false;
        }
    });

    $(document).off('click.saveCardIcon');
    $(document).on('click.saveCardIcon', '.form-check-label i.fa-lock', function(e) {
        const icon = $(this);
        const label = icon.closest('.form-check-label');
        const checkboxId = label.attr('for');

        if (!checkboxId) return;

        const checkbox = document.getElementById(checkboxId);
        if (!checkbox) return;

        checkbox.checked = !checkbox.checked;

        const event = new Event('change', { bubbles: true });
        checkbox.dispatchEvent(event);

        e.stopPropagation();
        return false;
    });
}

$(document).ready(initializePaymentMethods);
$(document).on('turbolinks:load', initializePaymentMethods);
